import { render, staticRenderFns } from "./luckyReferral.vue?vue&type=template&id=0078d826&scoped=true"
import script from "./luckyReferral.vue?vue&type=script&lang=js"
export * from "./luckyReferral.vue?vue&type=script&lang=js"
import style0 from "./luckyReferral.vue?vue&type=style&index=0&id=0078d826&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0078d826",
  null
  
)

export default component.exports